module.exports = __webpack_public_path__ + "static/img/exerciseBg.3cb16479.png";